import { useState } from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import { selectStylesLigth } from 'utils/helpers/structs/selectStyles';
import type { SelectOption } from '../types';

interface VendorFilterDlgBodyProps {
    initialId: number | null;
    vendorOptions: SelectOption[];
    selectTheme: typeof selectStylesLigth;
    label: string;
    placeholder: string;
    hint: string;
    onChange: (vendorId: number | null) => void;
}

/** Тіло діалогу без Auth/Settings-хуків — ModalProvider вище за AuthProvider */
const VendorFilterDlgBody = ({
    initialId,
    vendorOptions,
    selectTheme,
    label,
    placeholder,
    hint,
    onChange,
}: VendorFilterDlgBodyProps) => {
    const [value, setValue] = useState<number | null>(initialId);
    const selectId = 'products-select-vendor-filter';

    const handleChange = (option: SelectOption | null) => {
        const next = option?.value ?? null;
        setValue(next);
        onChange(next);
    };

    return (
        <Form.Group className="mb-0" style={{ marginTop: -8 }}>
            <label className="form-label text-muted" htmlFor={selectId}>
                {label}
            </label>
            <Select<SelectOption>
                inputId={selectId}
                options={vendorOptions}
                isClearable
                placeholder={placeholder}
                className="w-100"
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                styles={{
                    ...selectTheme,
                    control: (base, state) => ({
                        ...base,
                        ...(selectTheme.control ? selectTheme.control(base, state) : {}),
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 2000,
                    }),
                }}
                value={vendorOptions.find((vendor) => vendor.value == value) || null}
                onChange={handleChange}
                isMulti={false}
            />
            <p className="text-muted f-12 mb-0 mt-2">{hint}</p>
        </Form.Group>
    );
};

export default VendorFilterDlgBody;
